import { useEffect } from "react";
import { getFirebaseAuthorizationHeaders } from "./firebase-auth-headers";
import { isShortReferralCode } from "./referral-code";
import { JUNGLE_BACKEND_DOMAIN_FOR_ROUTES_MIGRATED_TO_CLOUDFLARE_WORKER } from "../../constants/GlobalTypesAndEnumsAndConstants";

/** Profile-backed work survives reloads/devices; only authenticated pending signups retry. */
export function usePendingReferral(uid?: string, code?: string | null) {
  useEffect(() => {
    if (!uid || !code || !isShortReferralCode(code)) return;
    let active = true, inFlight = false;
    const retry = async () => {
      if (!active || inFlight) return;
      inFlight = true;
      try {
        const headers = await getFirebaseAuthorizationHeaders();
        if (!active) return;
        await fetch(`${JUNGLE_BACKEND_DOMAIN_FOR_ROUTES_MIGRATED_TO_CLOUDFLARE_WORKER}/users/complete-pending-referral`, {
          method: "POST", headers: { "Content-Type": "application/json", ...headers },
          body: JSON.stringify({ user_id: uid }), signal: AbortSignal.timeout(10000),
        });
      } catch { /* Durable profile marker remains; retry after connectivity/auth recovery. */ }
      finally { inFlight = false; }
    };
    void retry();
    const timer = window.setInterval(() => void retry(), 30000);
    window.addEventListener("online", retry);
    return () => { active = false; window.clearInterval(timer); window.removeEventListener("online", retry); };
  }, [uid, code]);
}
